// extracted by mini-css-extract-plugin
module.exports =  {"contentContainer":"_contentContainer--2lTar","messageText":"_messageText--1_ECr"};